// interfaces
import { ICollectionsMainContent } from "../ICollectionsMain";

// assets
import PlayIcon from "@/components/icons/PlayIcon";

import styles from "@/assets/styles/containers/collections-main.module.scss";
import CollectionBox from "./CollectionBox";
import LandingPagination from "@/components/LandingPagination";

const CollectionsMainContent = (props: ICollectionsMainContent) => {
  const { collections, page, pages, openModal, exploreRef } = props;

  // classNames
  const contentLabelTextClassName = styles["locl-collections-main__content__label__text"];
  const contentDemoSectionClassName = styles["locl-collections-main__content__demo__section"];
  const contentDemoSectionTitleClassName = styles["locl-collections-main__content__demo__section__title"];
  
  // render
  return (
    <div className={styles["locl-collections-main__content"]} data-testid="locl-collections-main-content">
      <div className={styles["locl-collections-main__content__label"]}>
        <h2 className={contentLabelTextClassName}>THE FUTURE OF</h2>
        <h2 className={contentLabelTextClassName}>BOOKING</h2>
        <h2 className={contentLabelTextClassName}>EXPERIENTIAL</h2>
        <h2 className={contentLabelTextClassName}>SPACES</h2>
      </div>
      <div className={styles["locl-collections-main__content__main"]}>
        <p className={styles["locl-collections-main__content__main__desc"]}>
          Our team has pulled together an inspiring range for targeted campaign planning: the
          iconic, the new, and the previously undiscovered. By sector, by season, by social
          environment, we have a collection to propel your experiential space planning imagination.
        </p>
        <div className={styles["locl-collections-main__content__demo"]}>
          <div className={styles["locl-collections-main__content__demo__content"]}>
            <div className={contentDemoSectionClassName}>
              <h3 className={contentDemoSectionTitleClassName}>
                Search
              </h3>
              <p className={styles["locl-collections-main__content__demo__section__text"]}>
                filter spaces
                <br />
                strategically
              </p>
            </div>
            <div className={contentDemoSectionClassName}>
              <h3 className={contentDemoSectionTitleClassName}>
                Plan
              </h3>
              <p className={styles["locl-collections-main__content__demo__section__text"]}>
                create, save, export
                <br />
                campaigns
              </p>
            </div>
            <div className={contentDemoSectionClassName}>
              <h3 className={contentDemoSectionTitleClassName}>
                Book
              </h3>
              <p className={styles["locl-collections-main__content__demo__section__text"]}>
                transparent
                <br />
                fast and direct
              </p>
            </div>
            <p className={styles["locl-collections-main__content__demo__section__mobile-text"]}>
              See lo:live in action
            </p>
          </div>
          <div
            className={styles["locl-collections-main__content__demo__button"]}
            onClick={openModal}
            data-testid="locl-collections-main-content-demo-button"
          >
            <div className={styles["locl-collections-main__content__demo__button__circle"]}>
              <PlayIcon />
            </div>
            <p className={styles["locl-collections-main__content__demo__button__text"]}>
              See lo:live in action
            </p>
          </div>
        </div>
        <div className={styles["locl-collections-main__content__explore"]}>
          <h2
            className={styles["locl-collections-main__content__explore__title"]}
            ref={exploreRef}
            data-testid="locl-collections-main-content-explore-title"
          >
            Explore collections
          </h2>
          <div className={styles["locl-collections-main__content__explore__collections"]}>
            {collections.map((collection, index) => (
              <CollectionBox
                slug={collection.slug}
                pictureUrl={collection.pictureUrl}
                title={collection.title}
                caption={collection.caption}
                isDouble={[0, 3, 4].includes(index)}
                key={index}
              />
            ))}
          </div>
          <LandingPagination page={page} paginationUrl="/collections/" pages={pages} />
        </div>
      </div>
    </div>
  );
};

export default CollectionsMainContent;
